import { Outlet } from "react-router-dom";

import NotificationWrapper from "./notification-wrapper";
import SideBar from "../App Utility Bar/sidebar";
import NavBar from "../App Utility Bar/navbar";

import { useAppUtilityContext } from "../../Contexts/AppUtilityContext";

export default function AppComponentWrapper() {
  const {
    appUtilityProps: { hideNavigationBar },
  } = useAppUtilityContext();

  return (
    <div className="app-utility-container">
      <NotificationWrapper>
        {hideNavigationBar ? (
          <div className="app-content hidden-navigation">{<Outlet />}</div>
        ) : (
          <>
            <SideBar />
            <div className="app-content">{<Outlet />}</div>
            <NavBar />
          </>
        )}
      </NotificationWrapper>
    </div>
  );
}
